import { Pipe, PipeTransform } from '@angular/core';
import { AppRootContext } from '../bootstrap';

@Pipe({ name: 'imagePublicPath' })
export class ImagePublicPathPipe implements PipeTransform {

    constructor(private appRootContext: AppRootContext) {}

    transform(path: string): string {
        return this.appRootContext.globalInfo.config.cdnRoot + path + '?v=' + this.appRootContext.globalInfo.config.version;
    }
}
